<template>
	<section class="small-12 columns indexFeature flex justify-center animated fadeIn">
		<div class="small-12 large-11 description">
			<div class="small-12 large-5 verbiage">
				<h1 class="small-12">
					Grow your <span>real estate</span> portfolio on your terms.
				</h1>
				<p class="small-12">
					The Work OS that powers you to analyze, manage and grow your properties portfolio.
				</p>
				<div class="small-12 action flex">
					<router-link :to="{ name: 'SignUp' }" class="borderRadius50 primaryButton flex vertical-align justify-center">
						Get Started 
						<i class="material-icons">keyboard_arrow_right</i>
					</router-link>
				</div>
			</div>
			<div class="small-12 large-7 columns image">
				<picture class="small-12 flex vertical-align">
					<img :src="image" alt="Dude working on a bean bag">
				</picture>
			</div>
		</div>
	</section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'IndexFeature',

		/*
		**  Set up the data
		*/

		data: () => ({

			image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/index%2Fdude-working.png?alt=media&token=e9f38a82-53ef-4d91-8759-726832e6e0b4'

		}),

	}

</script>